import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { SettingsDrawer } from "@components-shared/mobile/settings-drawer";
import { Button } from "@components/buttons";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import {
	ErrorWrapper,
	PressureIndexChart,
} from "@features/offer/shared/statistics";
import { EventContext, LookupContext } from "@gp/components";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { observer } from "mobx-react";

import GroupedEventStatsChart from "./components/GroupedEventStatsChart";

export default observer(function MatchStatistics(props: {
	isSettingsDrawerOpen: boolean;
	onClose: (value: boolean) => void;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.displayStatisticsGroup === StatisticsGroups.LiveStats) {
		return (
			<>
				<GroupedMatchStatsDrawer
					store={store}
					isSettingsDrawerOpen={props.isSettingsDrawerOpen}
					onClose={props.onClose}
				/>
				<ErrorWrapper>
					<>
						{store.sportStatisticsStore.filteredMatchStats
							.pressureIndex && (
							<PressureIndexChart
								homeAwayTeams={
									store.sportStatisticsStore.homeAndAwayTeam
								}
								store={store.sportStatisticsStore.pressureIndex}
							/>
						)}

						{store.sportStatisticsStore.filteredMatchStats
							.groupedMatchStatisticsChartData && (
							<GroupedEventStatsChart
								store={store.sportStatisticsStore}
							/>
						)}
					</>
				</ErrorWrapper>
			</>
		);
	}

	return null;
});

const GroupedMatchStatsDrawer = observer(
	function GroupedMatchStatsDrawer(props: {
		store: EventViewStore;
		isSettingsDrawerOpen: boolean;
		onClose: (value: boolean) => void;
	}) {
		const { t } = useTranslation();

		const [matchFilter, setMatchFilter] = useState<string>(
			props.store.sportStatisticsStore.matchFilter
		);

		const event = useContext(EventContext);
		const { teams } = useContext(LookupContext);

		const homeTeam = teams.get(event.teamOneId || "");
		const awayTeam = teams.get(event.teamTwoId || "");

		if (homeTeam == null || awayTeam == null) {
			console.error("Expected teams, got one or more null.");
			return null;
		}

		return (
			<SettingsDrawer
				onClose={() => {
					setMatchFilter(
						props.store.sportStatisticsStore.matchFilter
					);
					props.onClose(false);
				}}
				isOpen={props.isSettingsDrawerOpen}
			>
				<div className="drawer__header">
					<div className="drawer__heading">
						{t("EVENT.HEADER.MATCH_STATS")}
					</div>
				</div>

				<div className="drawer__body">
					<div className="drawer__section">
						<div className="drawer__label label u-mar--bottom--reset">
							{t("EVENT.HEADER.FILTER_STATISTICS")}
						</div>

						{props.store.sportStatisticsStore.availableMatchStatsFilterOptions.map(
							(tab) => (
								<div
									key={tab.key}
									className="drawer__option input--radio"
								>
									<input
										type="radio"
										id={`radio-${tab.key}`}
										name="matchTabFilter"
										value={tab.key}
										checked={matchFilter === tab.key}
										onChange={() => setMatchFilter(tab.key)}
										className="input--radio__box"
									/>
									<label
										htmlFor={`radio-${tab.key}`}
										className="input--radio__label"
									>
										{t(tab.title)}
									</label>
								</div>
							)
						)}
					</div>
				</div>

				<div className="drawer__footer">
					<Button
						btnText={t("ACC_STATEMENT.BET_DETAILS.CLOSE_BTN")}
						onClick={() => {
							setMatchFilter(
								props.store.sportStatisticsStore.matchFilter
							);
							props.onClose(false);
						}}
						className="btn--med btn--block btn--primary--inverted drawer__action--secondary"
					/>

					<Button
						btnText={t("mybets:PAGE.FILTER_FORM.SUBMIT_BUTTON")}
						onClick={() => {
							props.store.sportStatisticsStore.setMatchFilter(
								matchFilter
							);
							props.onClose(false);
						}}
						className="btn--med btn--block btn--accent drawer__action--primary"
					/>
				</div>
			</SettingsDrawer>
		);
	}
);
